/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { PipeMiddlewareElement } from '../../middleware-pipe';
import type { ResultResponseDto } from '../../../../models/cose-api/response/result-response.dto';
import { makeLogger } from '../../../../logger/logger';
import type { PipeMiddlewareNext } from '../../middleware-pipe';

const { debug} = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/res-faq-documents-mapping.ts',
  loggersList: ['debug']
});

function getLocaleData(el: any, language: string, country: string) {
    // for data governance documents, the key is named "localized" instead of ll_CC
    const localeKey = el['localized'] ? 'localized' : `${language}_${country.toUpperCase()}`;
    if (el.hasOwnProperty(localeKey)) return el[localeKey];
    return el['en_WW'];
}

export const resCoseFaqDocumentsMapping: PipeMiddlewareElement<any, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
) => {

    debug('responseCoseFaqDocumentsMap BEFORE',details);

    const response = await next(details) as ResultResponseDto<any>;
    const newResponse = {...response};
    const isMyscniederFAQ = newResponse.facetsOptions.facets.some(el => el.id === 'access');
    const language = newResponse.language;
    newResponse.documents.map((el) => {
        const locale = getLocaleData(el, response.language, response.country );
        const newRange = [];
        if(locale?.range){
          if(Array.isArray(locale?.range)){
            locale?.range.forEach((range) =>
              newRange.push(range['translation']));
            el['relatedRanges'] = newRange;
          }
          else{
            el['relatedRanges'] = [locale?.range?.translation];
          }
        }

        if(el.relatedProducts){
          if(!Array.isArray(locale?.relatedProducts)){
            el.relatedProducts = [el.relatedProducts];
          }
        }
        el['description'] = locale?.description;
        delete locale?.description;
        el['title'] = locale?.title;
        delete locale?.title;
        el['url'] = isMyscniederFAQ ? `/myschneider/faq/${el.id}/${language}` : locale?.openUrl;
        delete locale?.openUrl;
        el['faqID'] = el?.id;
        delete el?.id;
        el['documentLanguage'] = response.language;

        if(el.image){
          el['video'] = true;
          el['videoThumbnail'] = Array.isArray(el.image) ? el.image[0] : el.image;
          delete el.image;}
        else{
          el['video'] = false;
        }
    });

    debug('responseCoseFaqDocumentsMap AFTER',newResponse);

    return new Promise(r=>r(newResponse));
};
